import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { useCurrentSmartview, useIsSmartviewMounted, useSmartviewManager } from '@morningtrain/react-smartviews'
import { HandleOuterClicksContext } from 'services/HandleOuterClicks'
import SmartviewOverlay from 'widgets/smartviews/partials/SmartviewOverlay'
import classNames from 'classnames'
import * as Animations from 'ui/animations'

function SmartviewSlideinSidebar (props) {
  const [smartview] = useCurrentSmartview()

  const [isSmartviewMounted, setIsSmartviewMounted] = React.useState(smartview !== null)

  React.useEffect(() => {
    const isSmartviewCurrentlyMounted = smartview !== null
    if (isSmartviewCurrentlyMounted !== isSmartviewMounted) {
      setIsSmartviewMounted((isSmartviewCurrentlyMounted))
    }
  }, [smartview, isSmartviewMounted])

  const smartviewManager = useSmartviewManager()
  const wrapperRef = React.createRef()
  const innerWrapperRef = React.createRef()

  const handleClickOutside = (event) => {
    if (props.ghost === true) {
      return
    }

    if (innerWrapperRef.current && !innerWrapperRef.current.contains(event.target)) {
      smartviewManager.handleClickOutside()
    }
  }

  const handleOuterClicksContext = React.useContext(HandleOuterClicksContext)

  React.useEffect(() => {
    handleOuterClicksContext.onClick(handleClickOutside)

    return () => {
      handleOuterClicksContext.removeOnClick(handleClickOutside)
    }
  })

  const currentSize = smartviewManager.config.get('size')
  const [size, setSize] = React.useState()

  React.useEffect(() => {
    if (size !== currentSize) {
      setSize(currentSize)
    }
  })

  const innerWrapperClassNames = [
    'transform',
    'transition-width',
    'ease-in-out',
    'duration-500',
    'sm:duration-700'
  ]

  /// Keep this to not have tailwind purge them
  const availableSizes = [
    'w-xs',
    'w-sm',
    'w-md',
    'w-lg',
    'w-xl',
    'w-2xl',
    'w-3xl',
    'w-4xl',
    'w-5xl',
    'w-6xl'
  ]

  const _innerClassName = classNames(
    'transition-width duration-500 ease-in-out',
    { [`w-${currentSize}`]: smartview },
    { 'w-xs': !smartview }
  )

  const _className = classNames(
    'h-full z-50 right-0 max-w-full flex',
    'shadow-lg',
    { relative: props.ghost },
    { fixed: !props.ghost }
  )

  return (
    <div>
      {/* <SmartviewOverlay /> */}
      <Animations.SlideIn direction='right' distance='100%' duration={500} in={isSmartviewMounted} unmountOnExit={false} animationContainer={false}>
        <section
          ref={wrapperRef}
          className={_className}
        >
          <div ref={innerWrapperRef} className={_innerClassName}>
            <div className='h-full flex flex-col bg-white overflow-y-auto' style={{ height: 'calc(100% - 7.5rem)' }}>
              {props.children}
            </div>
          </div>
        </section>
      </Animations.SlideIn>
    </div>
  )
};

SmartviewSlideinSidebar.defaultProps = {
  ghost: false,
  hiddenIfEmpty: false
}

SmartviewSlideinSidebar.propTypes = {
  ghost: PropTypes.bool,
  hiddenIfEmpty: PropTypes.bool
}

export default observer(SmartviewSlideinSidebar)
